export default __webpack_public_path__ + "static/media/full-cart.468a12fe.svg";